<div class="app-main__inner">

  <!-- ── Toolbar ────────────────────────────────────────────────────────────── -->
  <div class="ds-toolbar">
    <div class="ds-presets">
      <button class="ds-preset-btn" [class.active]="preset === 'today'"     (click)="setPreset('today')">Today</button>
      <button class="ds-preset-btn" [class.active]="preset === 'yesterday'" (click)="setPreset('yesterday')">Yesterday</button>
      <button class="ds-preset-btn" [class.active]="preset === 'month'"     (click)="setPreset('month')">This Month</button>
      <button class="ds-preset-btn" [class.active]="preset === 'custom'"    (click)="setPreset('custom')">Custom</button>
    </div>
    <ng-container *ngIf="preset === 'custom'">
      <input type="date" class="form-control form-control-sm ds-tb-date" [(ngModel)]="customFrom" />
      <span class="ds-tb-sep">to</span>
      <input type="date" class="form-control form-control-sm ds-tb-date" [(ngModel)]="customTo" />
      <button class="btn btn-primary btn-sm ds-go-btn" (click)="load()">Go</button>
    </ng-container>
  </div>

  <div *ngIf="error" class="alert alert-danger py-2 mb-2">{{ error }}</div>

  <div *ngIf="loading" class="ds-loading">
    <div class="spinner-border text-primary"></div>
    <span>Loading summary...</span>
  </div>

  <!-- ── Pivot table ────────────────────────────────────────────────────────── -->
  <div class="ds-pivot-wrap" *ngIf="loaded && !loading">

    <div *ngIf="!centers.length && !runners.length" class="ds-empty">No data for the selected period.</div>

    <table *ngIf="centers.length || runners.length" class="table table-bordered ds-pivot-table">
      <thead>
        <tr>
          <th class="ds-metric-col">Metric</th>
          <th class="ds-summary-hdr">Summary</th>
          <th *ngFor="let c of centers" class="ds-center-hdr text-center">{{ c.centerName }}</th>
          <!-- visual separator before runner columns -->
          <th *ngFor="let r of runners; let first = first"
              class="ds-runner-hdr text-center"
              [class.ds-sep]="first">{{ r.runnerName }}</th>
        </tr>
      </thead>

      <tbody>
        <!-- Subscriptions Collected -->
        <tr>
          <td class="ds-row-label">Subscriptions Collected <span class="ds-unit">(Rs)</span></td>
          <td class="ds-summary-val text-center">{{ fmt(summary?.subscriptions) }}</td>
          <td *ngFor="let c of centers" class="ds-center-val text-center">{{ fmt(c.subscriptions) }}</td>
          <td *ngFor="let r of runners; let first = first"
              class="ds-runner-val text-center"
              [class.ds-sep]="first">{{ fmt(r.subscriptions) }}</td>
        </tr>

        <!-- Members Serviced -->
        <tr>
          <td class="ds-row-label">Members Serviced</td>
          <td class="ds-summary-val text-center">{{ summary?.membersServiced }}</td>
          <td *ngFor="let c of centers" class="ds-center-val text-center">{{ c.membersServiced }}</td>
          <td *ngFor="let r of runners; let first = first"
              class="ds-runner-val text-center"
              [class.ds-sep]="first">{{ r.membersServiced }}</td>
        </tr>

        <!-- New Members Added -->
        <tr>
          <td class="ds-row-label">New Members Added</td>
          <td class="ds-summary-val text-center">{{ summary?.newMembers }}</td>
          <td *ngFor="let c of centers" class="ds-center-val text-center">{{ c.newMembers }}</td>
          <td *ngFor="let r of runners; let first = first"
              class="ds-runner-val text-center"
              [class.ds-sep]="first">{{ r.newMembers }}</td>
        </tr>
      </tbody>
    </table>

  </div>

</div>
